module.exports = __webpack_public_path__ + "static/media/ec.5e9624df.svg";